import { GetControleServicosByIdResponse } from "../../../data/daos/read/get_controle_servicos_by_id";
import { IGetControleServicosByIdUseCase } from "../../../presentation/useCases/read/get_controle_servicos_by_id_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetControleServicosByIdUseCase
 */

export class GetControleServicosByIdUseCase implements IGetControleServicosByIdUseCase {
  constructor(private readonly repository: IObrasRepository) {}

  async getControleServicosById(id: number): Promise<GetControleServicosByIdResponse> {
    const response = await this.repository.getByIdControleServicos({ id });
    return response;
  }
}
